import React from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useWarehouseModel } from "../warehouseModel";
import { useNavModel } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";

export const DataBox = () => {
    const { selectedRowKeys, updateEditFormVal, setAddWaerVisible } = useWarehouseModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel();

    const onEdit = () => {
        if (!selectedRowKeys) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "13-3-1";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRowKeys, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "仓库跳转详情",
                type: "warning",
                text: "您还有仓库详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRowKeys, mode: "edit" });
                    updateEditFormVal(null);
                }
            })
        }
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.DATA_W_AD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => setAddWaerVisible(true)}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DATA_W_ED}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
    </>;

    return (
        <YhBox action={action} style={{ height: 'calc(100vh - 120px)' }}>
            <DataTable />
        </YhBox>
    )
}